<div
        [class.with-label]="withLabel"
        class="wrapper"
>
    <div
            (click)="!readonly && updateAndEmitToggle()"
            [class.active]="value"
            [class.disabled]="disabled"
            [class.loading]="isLoading"
            [class.with-animation]="!isLoading && !skipAnimation"
            class="switch"
    >
    </div>

    <span
            *ngIf="withLabel"
            class="switch-label"
    >{{ value ? ('lta-switch.on' | translate) : ('lta-switch.off' | translate) }}</span>
</div>
